// "" means same-origin: every API path is requested relative to the app host.
// "/" is accepted as a synonym so the build script can require a non-empty value.
const raw = (process.env.REACT_APP_BASE_API_URL ?? "").trim();

export const API_BASE_URL = raw === "/" ? "" : raw.replace(/\/+$/, "");
